import { render, staticRenderFns } from "./PendingVerificationTab.vue?vue&type=template&id=7c90b7d0"
import script from "./PendingVerificationTab.vue?vue&type=script&lang=js"
export * from "./PendingVerificationTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports